import React from "react";
import { settingNavList } from "../Layout/navbarConstants";
import Link from "next/link";

interface SettingsNavigationProp {
  title?: string;
}

const SettingsNavigation = (props: SettingsNavigationProp) => {
  const { title } = props;

  return (
    <>
      <ul className="w-full flex flex-row justify-between lg:flex-col">
        {settingNavList.map((item, idx) => (
          <li key={idx}>
            <Link href={`/settings/` + item.slug}>
              <div
                className={`cursor-pointer relative flex xs:text-sm lg:text-base items-center justify-start py-3 md:px-4 lg:rounded-md lg:hover:dark:bg-custom-900 lg:hover:bg-storm-dust-200 lg:hover:dark:text-white lg:hover:text-neutral-800 lg:hover:font-medium xs:whitespace-nowrap lg:whitespace-auto ${
                  item.name.toLowerCase() === title.toLowerCase()
                    ? "dark:lg:bg-neutral-150 lg:bg-custom-30 font-medium dark:text-white text-neutral-150"
                    : "bg-transparent font-normal dark:text-custom-300 text-custom-310"
                } __link-setting-${item.slug}`}
              >
                <p className="hidden md:inline-flex w-10 items-center justify-center whitespace-nowrap ">
                  {item.icon}
                </p>
                {item.name}
                <span
                  className={`xs:inline-block lg:hidden absolute z-9 mb-[2.5px] -bottom-1 left-0 h-[3px] w-full bg-primary-600 lg:hover:opacity-100 ${
                    item.name.toLowerCase() === title.toLowerCase()
                      ? "opacity-60"
                      : "opacity-0"
                  }`}
                />
              </div>
            </Link>
          </li>
        ))}
      </ul>
    </>
  );
};

export default SettingsNavigation;
